<template>
   <div class="notification-modal">
       <div class="notification-modal__box">
        <a class="notification-modal__close" @click.prevent="$store.commit('savedModal', false)" href="#">
            <svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18 18"><path fill-rule="evenodd" clip-rule="evenodd" d="M.5 9C.5 4.324 4.324.5 9 .5s8.5 3.824 8.5 8.5-3.824 8.5-8.5 8.5S.5 13.676.5 9ZM9 1.5C4.876 1.5 1.5 4.876 1.5 9c0 4.124 3.376 7.5 7.5 7.5 4.124 0 7.5-3.376 7.5-7.5 0-4.124-3.376-7.5-7.5-7.5Z" fill="#4D4D4D"/><path fill-rule="evenodd" clip-rule="evenodd" d="M11.617 6.382a.5.5 0 0 1 0 .708L7.09 11.617a.5.5 0 1 1-.707-.707l4.528-4.528a.5.5 0 0 1 .707 0Z" fill="#4D4D4D"/><path fill-rule="evenodd" clip-rule="evenodd" d="M6.382 6.382a.5.5 0 0 1 .707 0l4.528 4.528a.5.5 0 1 1-.707.707L6.382 7.09a.5.5 0 0 1 0-.708Z" fill="#4D4D4D"/></svg>
        </a>
            <div class="notification-modal__wrap">
               <div class="notification-modal__title">saving a space?</div>
               <div class="notification-modal__description">Sign up to start saving centres & spaces. It only takes a minute!</div>
               <div class="notification-modal__button">
                   <ButtonPrimary title="Sign Up" @buttonClick="signUp()"></ButtonPrimary>
               </div>
            </div>
       </div>
       <div class="notification-modal__bg" @click.prevent="$store.commit('savedModal', false)"></div>
   </div>
</template>

<script>
import ButtonPrimary from "../../components/global/ButtonPrimary"

    export default {
        name: 'SavedSpacesModal',
        data: () => ({
        }),
        props: {
        },
        watch: {
        },
        components: {
            ButtonPrimary
        },
        computed: {
        },
        mounted() {
        },
        created() {
        },
        methods: {
            signUp () {
                window.location.href = '/signup'
            }
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import "../../scss/global/includes";
   .notification-modal {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 10009;
    text-align: center;
    color: $primary-grey;
   }

   .notification-modal__box {
    position: absolute;
    top: 50%;
    left: 50%;
    background: $white;
    border-radius: 4px;
    width: 360px;
    height: 360px;
    display: flex;
    align-items: center;
    @include transform(translate(-50%, -50%));
   }

   .notification-modal__close {
    position: absolute;
    top: 8px;
    right: 8px;

    svg {
        width: 18px;
        display: block;
    }
   }

   .notification-modal__description {
    padding: 0 24%;
    margin-bottom: 24px;
    @include responsive-text-size('Body--16--Regular');
   }

   .notification-modal__title {
    @include responsive-text-size('Header--16--BOLD');
    margin-bottom: 24px;
   }

   .notification-modal__bg {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: -1;
   }


</style>
